import { memo } from 'react';
import { CallCardHistoryGrid } from '@/components/callcard/CallCardHistoryGrid';

interface CallCardHistoryTabProps {
  callLocFormattedAddress: string;
}

export const CallCardHistoryTab = memo(function CallCardHistoryTab({
  callLocFormattedAddress,
}: CallCardHistoryTabProps) {
  return (
    <div className="tab-content-panel">
      <CallCardHistoryGrid
        callLocFormattedAddress={callLocFormattedAddress}
        active={true}
      />
    </div>
  );
});
